/**
 * Owner ids arrive as opaque strings during the owner_id -> owner_profile_id
 * migration: all-digits values are legacy numeric customuser ids, anything
 * else is a profile UUID.
 */
export function isLegacyOwnerId(value: string | null | undefined): boolean {
  return !!value && /^\d+$/.test(value);
}
